import { render, staticRenderFns } from "./eod-event-dialog.vue?vue&type=template&id=2b528f7c"
import script from "./eod-event-dialog.vue?vue&type=script&lang=js"
export * from "./eod-event-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports